module.exports = __webpack_public_path__ + "img/historia_3-4_768.ab118212.webp";